import {
  extendTheme,
  ThemeOptions,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles'
import { PropsWithChildren } from 'react'

import { globalStyles, spacing } from './util'

export function ThemeProvider({
  themeOptions,
  children,
}: PropsWithChildren<{ themeOptions: ThemeOptions }>) {
  const { palette, ...restOfThemeOpts } = themeOptions

  const theme = extendTheme({
    colorSchemes: {
      light: {
        palette,
      },
    },
    ...restOfThemeOpts,
  })

  const vars = `
    ${spacing(theme.spacing(1))}
  `

  return (
    <MuiThemeProvider theme={theme}>
      <style>{`:root {${vars}}`}</style>
      <style>{globalStyles}</style>
      {children}
    </MuiThemeProvider>
  )
}
